import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a product price.
 * This component listens for variant update events and updates the price display accordingly.
 * It handles price updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 */
class ProductPrice extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  /**
   * Updates the price.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updatePrice = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newPrice = event.detail.data.html.querySelector('product-price [ref="priceContainer"]');
    const currentPrice = this.querySelector('[ref="priceContainer"]');

    // console.log('[PRICE UPDATE DEBUG] Found new price:', !!newPrice);
    // console.log('[PRICE UPDATE DEBUG] Found current price:', !!currentPrice);

    if (!newPrice || !currentPrice) return;

    // console.log('[PRICE UPDATE DEBUG] new compare group present:', !!newPrice.querySelector('.compare-price-group'));
    // console.log('[PRICE UPDATE DEBUG] current compare group present:', !!currentPrice.querySelector('.compare-price-group'));

    // Replace the entire price container contents from the server/fast-path response.
    // Both the slow path (server fetch) and fast path (client-side clone) always produce
    // a correctly-structured container — compare group present only when needed.
    // Surgical value-only updates caused the compare group to persist when switching
    // to a variant with no compare price (and fail to appear when switching the other way).
    if (currentPrice.innerHTML !== newPrice.innerHTML) {
      currentPrice.innerHTML = newPrice.innerHTML;
    }

    // console.log('[PRICE UPDATE DEBUG] Replaced price container innerHTML');
  };

}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}
